import { CONVERSIONS } from '../constants';

/**
 * Formats distance measurement in both metric and imperial units.
 *
 * Automatically chooses appropriate units based on distance:
 * - Metric: m for short distances, km for long distances (≥1,000 m)
 * - Imperial: ft for short distances, mi for long distances (≥5,280 ft)
 *
 * @param distanceInMeters - Distance value in meters
 * @returns Formatted string with both metric and imperial units
 *
 * @example
 * formatDistance(150);     // "150 m / 492 ft"
 * formatDistance(2500);    // "2.50 km / 1.55 mi"
 */
export const formatDistance = (distanceInMeters: number): string => {
  let metricText = '';
  if (distanceInMeters >= CONVERSIONS.METERS_PER_KILOMETER) {
    const kilometers = (
      distanceInMeters / CONVERSIONS.METERS_PER_KILOMETER
    ).toFixed(2);
    metricText = `${kilometers} km`;
  } else {
    const meters = Math.round(distanceInMeters);
    metricText = `${meters} m`;
  }

  const distanceInFeet = distanceInMeters * CONVERSIONS.METERS_TO_FEET;
  let imperialText = '';

  if (distanceInFeet >= CONVERSIONS.FEET_PER_MILE) {
    const miles = (distanceInFeet / CONVERSIONS.FEET_PER_MILE).toFixed(2);
    imperialText = `${miles} mi`;
  } else {
    const feet = Math.round(distanceInFeet);
    imperialText = `${feet.toLocaleString()} ft`;
  }

  return `${metricText} / ${imperialText}`;
};
